import { useQuery } from "@tanstack/react-query";
import { testingAxios, testingAuthHeaders } from "@/services/testing";
import { planEndpoint } from "@/services/testing";
import type { TestPlan } from "@/services/testing";
import { useAuthStoreV1 } from "@/stores/authStore_v1";

async function fetchPlan(planId: string): Promise<TestPlan> {
  const r = await testingAxios.get<TestPlan>(planEndpoint(planId), { headers: testingAuthHeaders() });
  return r.data;
}

export function usePlan(planId: string | null) {
  const token = useAuthStoreV1((s) => s.token);
  const orgId = useAuthStoreV1((s) => s.selectedOrg?.id ?? null);
  const userId = useAuthStoreV1((s) => s.user?.id ?? null);
  return useQuery({
    queryKey: ["testingPlan", planId, orgId],
    queryFn: () => fetchPlan(planId!),
    enabled: !!(token && orgId && userId && planId),
    refetchOnWindowFocus: false,
    // Background detail fetch — a transient failure (service busy mid-run) must
    // not raise the global error toast; react-query retries and it self-heals.
    meta: { silent: true },
    retry: 3,
  });
}
